import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "@/api/apiEndpoints";

export const fetchAndStoreWhoAmI = async () => {
  const result = await apiRequest(
    `${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.AUTH.WHOAMI}`,
    "GET"
  );

  if (result) {
    localStorage.setItem("role", result.role);
    localStorage.setItem("is_hybrid", String(Boolean(result.is_hybrid)));
    if (result.secondary_role) {
      localStorage.setItem("secondary_role", result.secondary_role);
    } else {
      localStorage.removeItem("secondary_role");
    }
  }

  return result;
};
